import { render, staticRenderFns } from "./subscription-details-page.vue?vue&type=template&id=0beb4c04&scoped=true&lang=pug"
import script from "./subscription-details-page.js?vue&type=script&lang=js&external"
export * from "./subscription-details-page.js?vue&type=script&lang=js&external"
import style0 from "./subscription-details-page.vue?vue&type=style&index=0&id=0beb4c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb4c04",
  null
  
)

export default component.exports